import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Link } from 'components/navigation/Link/Link';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useEventHandler } from 'hook/event.hook';

import './FrozenCardLink.scss';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';

export const FrozenCardLink = props => {
  const copy = props.additionalCopy ? props.additionalCopy : 'Un-freeze to use';
  const eventHandler = useEventHandler();

  const frozenLinkClickCallback = () => {
    eventHandler(CLICK, {
      'Click Type': 'Card is Frozen - Gear',
      Vertical: BANKING_VERTICAL,
    });
    if (typeof props.onClickCallback === 'function') {
      props.onClickCallback();
    }
  };

  return (
    <FlexContainer className="FrozenCardLinkWrapper items-align-end">
      <Link
        to={'/cash/manage'}
        onClickCallback={frozenLinkClickCallback}
        className=" margR4 fontBlue100 bold"
      >
        <div className="frozen-icon margR4 inblock"></div>
        Card is frozen{' '}
      </Link>
      <span className="italic Body-2">{copy}</span>
    </FlexContainer>
  );
};
